import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { formatStringToDisplayCase } from 'pubweb-smokey/dist/utils/formatters';
import RetailerCard from './RetailerCard';

import { LocationsCityListingAccordionStyles } from './LocationsCityListingAccordion.styled';

const LocationsCityListingAccordion = ({
  city,
  storesByCity,
  isOpen,
  onHeaderClick,
}) => {
  return (
    <LocationsCityListingAccordionStyles>
      <button onClick={onHeaderClick} className="city-accordion-title">
        <div>
          {city && (
            <h2 className="city-heading h4">
              {formatStringToDisplayCase(city)}
            </h2>
          )}
          {storesByCity && storesByCity.length > 1 ? (
            <p>{storesByCity.length + ' stores'}</p>
          ) : (
            <p>{storesByCity.length + ' store'}</p>
          )}
        </div>
        <div>
          <div className="accordion-chevron">
            <Image
              src={
                isOpen
                  ? '/public-assets/images/chevron-dwn.svg'
                  : '/public-assets/images/chevron-right.svg'
              }
              alt="Chevron"
              width="16"
              height="16"
            />
          </div>
        </div>
      </button>

      {isOpen && (
        <div className="city-accordion-contents">
          <div className="retailer-card-container">
            {storesByCity &&
              storesByCity.map((store, i) => {
                if (store.navigationSlug === 'american-home-center') {
                  store.name = 'Future Homes of Tacoma';
                  store.navigationSlug = 'future-homes-of-tacoma';
                }
                return <RetailerCard key={i} store={store} />;
              })}
          </div>
        </div>
      )}
    </LocationsCityListingAccordionStyles>
  );
};

LocationsCityListingAccordion.propTypes = {
  city: PropTypes.any,
  isOpen: PropTypes.any,
  onHeaderClick: PropTypes.any,
  storesByCity: PropTypes.array,
};

export default LocationsCityListingAccordion;
